import { cn } from '@/lib/utils'

interface ColorChipProps {
  hex: string
  className?: string
}

export function ColorChip({ hex, className }: ColorChipProps) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 px-1.5 py-0.5 rounded-md bg-muted/30 border", className)}>
      <div 
        className="w-3 h-3 rounded-full border border-white shadow-sm ring-1 ring-black/10" 
        style={{ backgroundColor: hex }}
      />
      <span className="text-xs font-mono">{hex}</span>
    </span>
  )
}